import axiosClient from "./axiosClients";

const uri = "/promotions";

class PromotionApi {
  getAll = () => {
    return axiosClient.get(uri);
  };

  getById = (id) => {
    return axiosClient.get(`${uri}/${id}`);
  };
}
const promotionApi = new PromotionApi();
export default promotionApi;
